/**
 * 文档 https://liveme.feishu.cn/docx/doxcnckijDnvKtA9CIEy4pClQWh
 */
import { loadJs } from '../utility';
import {
  IsPC
} from '../uaInfo';

const langJSON = {
  ar: {
    title: 'لغز التحقق'
  },
  en: {
    title: 'Puzzle Verification'
  },
  es: {
    title: 'Puzle de verificación'
  },
  ru: {
    title: 'Пазл верификации'
  },
  pt: {
    title: 'Quebra-cabeça de Validação'
  },
  ja: {
    title: 'パズル検証'
  },
  zh: {
    title: '拼圖驗證'
  }
};

// 数美验证码实例
let SMCaptcha = null;
// 加载标志
let loadFlag = false;
// 初始化标志
let initFlag = false;
// 加载数美验证码js的resolve列表
const loadSMCaptchaJSResolveList = [];
// 初始化数美验证码方法传入的cb列表
// const initSMCaptchaCallbackList = [];
// 初始化数美验证码方法传入的onClose列表
// const initSMCaptchaOnCloseList = [];
// 是否已经初始化
export const hasSMCaptcha = () => !!SMCaptcha;
// 获取SMCaptcha实例
export const getSMCaptcha = () => SMCaptcha;

// 执行加载数美验证码js的resolve列表
const doLoadSMCaptchaJSResolveList = (property) => {
  let item = loadSMCaptchaJSResolveList.shift();
  while (item) {
    item[property] && item[property]();
    item = loadSMCaptchaJSResolveList.shift();
  }
};

const lang = langJSON[navigator.language.toLowerCase().split('-')[0]] || langJSON.en;

/**
* 加载数美验证码js
* @param {string} url 数美验证码js url地址
* @returns Promise
*/
export const loadSMCaptchaJS = (url = null) => new Promise((resolve, reject) => {
  // 是否有数美挂载的initSMCaptcha，有就表示js已经加载
  if (window.initSMCaptcha) {
    resolve();
  } else {
    // 收集resolve
    loadSMCaptchaJSResolveList.push({ resolve, reject });
    // 通过loadFlag控制，只发一起一次loadJs
    if (loadFlag) {
      return;
    }
    loadFlag = true;
    loadJs(url || 'https://castatic-xjp.fengkongcloud.com/pr/v1.0.4/smcp.min.js').then(() => {
      doLoadSMCaptchaJSResolveList('resolve');
    }).catch(() => {
      doLoadSMCaptchaJSResolveList('reject');
      loadFlag = false;
    });
  }
});

const appendCustomStyle = () => {
  const style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = `
  .shumei_captcha_mask {
    opacity: .4 !important;
    filter: alpha(opacity=4) !important;
    z-index: 1000000001 !important;
  }
  .shumei_captcha_popup_wrapper {
    border-radius: 18px !important;
    z-index: 1000000002 !important;
  }
  .shumei_captcha_popup_wrapper .shumei_captcha_wrapper {
    border-radius: 18px !important;
  }
  .shumei_captcha_img_loaded_wrapper .shumei_captcha_img_loaded_bg_wrapper img, .shumei_captcha_img_loaded_wrapper .shumei_captcha_img_loaded_fg_wrapper img {
    border-radius: 10px !important;
  }
  .shumei_catpcha_header_wrapper .refresh-btn, .shumei_catpcha_header_wrapper .close-btn {
    top: 17px !important;
  }
  `;
  document.getElementsByTagName('head').item(0).appendChild(style);
};

/**
* 初始化数美验证码
* @param {Object} options 数美配置
* @param {Function} callback 初始化完成的回调
*/
export const initSMCaptcha = ({ options = {}, callback, onClose }) => {
  // callback && initSMCaptchaCallbackList.push(callback);
  // onClose && initSMCaptchaOnCloseList.push(onClose);
  loadSMCaptchaJS().then(() => {
    // 只初始化一遍数美验证码
    if (!initFlag) {
      initFlag = true;
      const isHttps = window.location2.protocol == 'https:';
      const params = Object.assign({
        // 【必填】数美分配的公司标识，数美后台可以查看
        organization: window.ISONLINE ? 'lNkCs6Z3xVCcTBQPkKLu' : 'lNkCs6Z3xVCcTBQPkKLu',
        // 连接新加坡机房特殊配置项，仅供验证码数据上报新加坡机房客户使用
        domains: ['captcha-xjp.fengkongcloud.com'],
        // 应用标识，区分不同应用，数美后台可以管理
        appId: 'default',
        // 推广渠道，可自定义
        channel: 'default',
        // 展现形式，支持：embed（嵌入式）、float（浮动式）、popup（弹出层）
        product: 'popup',
        // 模式: 支持slide（滑动验证码）、select（文字点选验证码）、 icon_select(图标点选验证码)、 seq_select(成语语序验证码)、spatial_select(空间逻辑)
        mode: 'icon_select',
        // 支持zh-cn（中文）、en（英文）、ph（菲律宾语）、ina（印尼语）、tha（泰语）、vn（越南语）、mys（马来语）、jp（日语）及kr(韩语)
        // lang: 'zh-cn',
        // 是否高优使用浏览器设置的语言作为验证码的语言
        useBrowserLang: true,
        // 需要传验证码加载的位置Id，dom的id值 embed（嵌入式）、float（浮动式）必须配置，popup（弹出层）不需要
        appendTo: '',
        // 自定义数据
        customData: {},
        // 自定义滑块样式,仅滑块验证支持自定义设置, 滑块验证默认值:”向右滑动滑块填充拼图”
        // 'tipsMessage.sliderPlaceholder': '',
        // 初始状态是否禁用验证码
        disabled: false,
        // 加载资源是否是https，默认和当前页面协议一致
        https: isHttps,
        // 验证码宽度，单位支持数字、%、px，建议最小宽度为300px，宽高比建议为2:1
        width: IsPC ? '303px' : '80%',
        // 自定义样式
        style: {
          hideRefreshOnImage: true, // 是否隐藏图片上的刷新按钮
          headerTitle: lang.title,
          slideBar: {
            background: '#F5F2F5', // 进度条背景色
            successColor: '#4CD65F', // 成功时字体颜色
            border: 'none', // 进度条边框，目前只是用来设置清除边框
            successBorder: '1px solid #4CD65F', // 成功时边框
            process: {
              background: '#FAEEFF', // 拖动时进度条颜色
              successBackground: '#DBF2DF', // 成功时背景色
              failBackground: '#F2DCD8', // 失败时背景色
              border: '1px solid #AD4EEC', // 拖动时进度条边框
              failBorder: '1px solid #FB543B' // 失败时进度条边框
            },
            button: {
              boxShadow: 'none', // 一般用来去掉按钮阴影用
              color: '#AD4EEC', // 默认情况下按钮中iconfont的颜色
              border: '1px solid #AD4EEC', // 默认情情况按钮边框
              failColor: '#FB543B', // 失败时iconfont颜色
              failBorder: '1px solid #FB543B', // 失败时按钮边框
              background: '#FFF' // 默认按钮背景色
            }
          }
        },
        // 开发过程中可以开启，出现异常会打印log，方便开发；上线后，务必关闭
        debug: false,
        // popup模式有效，遮罩层绑定关闭弹层事件
        maskBindClose: () => {
          console.log('maskBindClose!');
        },
        onError: (errType, errmMsg) => {
          console.log('onError!', errType, errmMsg);
        },
        onInit: (captchaUuid) => {
          // 第一时间获取到验证码内部的uuid，供业务方进行打点
          console.log('收到', captchaUuid);
        }
      }, options);
      // 执行数美挂载到window上的initSMCaptcha方法
      window.initSMCaptcha(params, (instance) => {
        console.log('initSMCaptcha callback', instance);
        SMCaptcha = instance;

        appendCustomStyle();

        // 验证码校验情况回调
        SMCaptcha.onSuccess((data) => {
          // {rid: "2017080810405655b3377d25de478233", pass: false}
          // 这里可以获取前端验证状态,pass为true验证码前端验证成功;pass为false,前端验证失败,需要可以提醒用户
          if (data.pass) {
            console.log(`验证码: ${data.rid}`);
          }
        });

        // 资源加载异常,建议开发时进行监听,便于查询错误
        SMCaptcha.onError((errType, errMsg) => {
          console.log('onError');
          // errType: SERVER_ERROR
          // errMsg: {code: 2002, message: "服务器异常: 无权限操作(invalid organization)"}
          console.log('onError', errType, errMsg);
        });

        // 验证码所有资源（前端资源及图片）都加载就绪，并且onReady回调参数中有一个type字段，用以区分哪个环境的加载成功。type: init - 初始化时; refresh - 手动刷新图片后; afterFail - 验证失败重新加载图片后;
        SMCaptcha.onReady((dom, readyParams) => {
          console.log('SMCaptcha', 'onReady', readyParams.type);
          if (readyParams.type === 'init') {
            callback && callback(instance);
            // let cb = initSMCaptchaCallbackList.shift();
            // while (cb) {
            //   cb && cb(instance);
            //   cb = initSMCaptchaCallbackList.shift();
            // }
          }
        });
        // 关闭验证码弹窗回调
        SMCaptcha.onClose(() => {
          // 在onReady内调用onClose是无效的
          onClose && onClose();
          // let oc = initSMCaptchaOnCloseList.shift();
          // while (oc) {
          //   oc && oc();
          //   oc = initSMCaptchaOnCloseList.shift();
          // }
        });
      });
    } else if (hasSMCaptcha()) {
      // 如果已经有数美验证码实例，立即执行callback
      callback && callback(SMCaptcha);
    }
  });
};

// 主动刷新或重置验证码使用
export const smCaptchaReset = () => {
  if (hasSMCaptcha()) {
    SMCaptcha.reset();
  }
};

// 显示数美验证码
export const showSMCaptcha = () => {
  console.log('showSMCaptcha');
  if (hasSMCaptcha()) {
    console.log('showSMCaptcha', 'hasSMCaptcha', SMCaptcha);
    smCaptchaReset();
    SMCaptcha.verify();
  }
};

// 关闭数美弹窗
export const closeSMCaptchaPopup = () => {
  if (hasSMCaptcha()) {
    SMCaptcha.closePopup();
  }
};

window.KEWLSMCaptcha = {
  loadSMCaptchaJS,
  initSMCaptcha,
  getSMCaptcha,
  hasSMCaptcha,
  showSMCaptcha,
  closeSMCaptchaPopup,
  smCaptchaReset
};
